import React, { ReactNode } from 'react';

interface Props {
  children: string;
  red?: boolean;
}

export const Stamp = (props: Props): ReactNode => {
  const className: string[] = ['stamp border border-round border-double'];
  if (props.red) {
    className.push('alert');
    className.push('border-red-700');
  } else {
    className.push('border-700');
    className.push('text-700');
  }

  return <span className={className.join(' ')}>
    {props.children}
  </span>;
};
